var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 3.33334H3.33333M14 3.33334H12.6667M12.6667 3.33334V12.6667C12.6667 13.7712 11.7712 14.6667 10.6667 14.6667H5.33333C4.22876 14.6667 3.33333 13.7712 3.33333 12.6667V3.33334M12.6667 3.33334H10.6667M3.33333 3.33334H5.33333M5.33333 3.33334V3.33334C5.33333 2.22877 6.22876 1.33334 7.33333 1.33334H8.66667C9.77124 1.33334 10.6667 2.22877 10.6667 3.33334V3.33334M5.33333 3.33334H10.6667M6.66667 6.24562V11.8597M9.33333 6.24562V11.8597",
    stroke: "white",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.78eca7638df35b6557fcfedea6cec2ff.svg";
export { ForwardRef as ReactComponent };